import { useBoolean } from "@fluentui/react-hooks";
import { Dialog, DialogContent, DialogFooter } from "@fluentui/react/lib/Dialog";
import { Panel, PanelType } from "@fluentui/react/lib/Panel";
import { mergeStyles } from "@fluentui/react/lib/Styling";
import { ITextFieldStyles } from "@fluentui/react/lib/TextField";
import stylesTimeLine from './FlowFolder/WorkspaceItemFlow.module.css';

import MuiAlert, { AlertColor } from "@mui/material/Alert";
import { Close, Delete } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Btn from "../../components/Button/Btn";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import { useUpload } from "../../context/UploadProvider/useUpload";
import { usePanelWidth } from "../../functions/hooks/usePanelWidth";
import { Delete as DeleteItem } from "../../services/Item/ItemServicesCRUD";
import { GetOneItem } from "../../services/Item/ItemServicesGet";
import { FlowProps, WorkspaceItemFlowComponent } from "./FlowFolder/WorkspaceItemFlowComponent";
import MoveInBatch from "./MoveInBatch/MoveInBatch";
import CopyFolderStructureDrawer, { CopyFolderStructureDrawerParameters } from "./PanelItens/CopyFolderStructureDrawer";
import CreateFolderComp, { NewFolderConfig } from "./PanelItens/CreateFolderComp";
import EditFolder, { EditFolderOpen } from "./PanelItens/EditFolder";
import RenameComp, { RenameConfig } from "./PanelItens/RenameComp";
import ShareFile, { ShareFileConfig } from "./PanelItens/ShareFile/ShareFileComp";
import ValidateDocument, { TemporalityConfig } from "./PanelItens/TemporalityDocument";
import styles from "./WorkSpaceItemList.module.css";
import { filesSelected, WorkSpaceItemListFileConfigSearch } from "./WorkSpaceItemListFile";
import WorkSpaceItemListFolder from "./WorkSpaceItemListFolder";
import WorkSpaceItemListFileRevisionComponent from "./WorkSpaceItemRevisionComp";
import { KeyDriveDrawer } from "../../components/KeydriveComponents/Drawer/KeyDriveDrawer";
import { useSearchConfig } from "../../context/SearchConfigProvider/useSearchConfig";
import { SearchType, WorkSpaceItem } from "../../model/ItemModel";
import KeydriveSnackbar from "../../components/KeydriveComponents/Snackbar/KeydriveSnackbar";
import { FileListHash } from "../../context/UploadProvider/typesUpload";
import { KeyDriveDialog } from "../../components/KeydriveComponents/Dialog/KeyDriveDialog";
import { DeleteIcon } from "../../assets/icons/deleteIcon";

const exampleChildClass = mergeStyles({
	display: "block",
	marginBottom: "10px",
});

const textFieldStyles: Partial<ITextFieldStyles> = {
	root: { maxWidth: "300px" },
};

const WorkSpaceItemMain = (props: any) => {
	const { t, i18n } = useTranslation();
	const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);
	const [isOpenDrawer,setIsOpenDrawer] = useState<boolean>(false);
	const [userEdit, setUserEdit] = useState<string | undefined | number>(0);
	const [reload, setReload] = useState<boolean>(false);
	const [searchName, setSearchName] = useState<string>("");
	const profile = useProfile();
	const { nameOrg, idWorkspace, idFolder } = useParams();
	const [showSnackBar, setShowSnackBar] = useState<boolean>(false);
	const upload = useUpload();
	const [newFolderConfig, setNewFolderConfig] = useState<NewFolderConfig | undefined>(undefined);
	const [renameConfig, setRenameConfig] = useState<RenameConfig | undefined>(undefined);
	const [temporalityConfig, setTemporalityConfig] = useState<TemporalityConfig | undefined>(undefined)
	const [idFileDeted, setIdFileDeted] = useState<string | undefined>(undefined);
	const [itemDelete, setItemDelete] = useState<WorkSpaceItem | undefined>(undefined);
	const [idFileRevision, setIdFileRevision] = useState<string | undefined>(undefined);
	const [hideDialog, setHideDialog] = useState<boolean>(true);
	const [hideDialogMove, setHideDialogMove] = useState<boolean>(true);
	const [itemMove, setItemMove] = useState<string>("");
	const [messageSnack, setMessageSnack] = useState<string | undefined>(undefined);
	const [alertColor, setAlertColor] = useState<AlertColor>("success");
	const [idFolderInternal, setIdFolderInternal] = useState<string | undefined>(idFolder);
	const [editFolderOpen, setEditFolderOpen] = useState<EditFolderOpen | undefined>(undefined);
	const [copyFolderStructureDrawerParameters, setCopyFolderStructureDrawerParameters] = useState<CopyFolderStructureDrawerParameters | undefined>(undefined);
	const [shareFileConfigOpen, setShareFileConfigOpen] = useState<ShareFileConfig | undefined>(
		undefined,
	);
	const [flowProps, setFlowProps] = useState<FlowProps | undefined>(undefined)
	const [openModalFlow, setOpenModalFlow] = useState<boolean>(false)
	const [reloadFolder, setReloadFolder] = useState<boolean>(false);
	const [searchParams, setSearchParams] = useSearchParams();
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
	const [fileToMove, setFileToMove] = useState<filesSelected>();
	const [isMovedSuccess, setIsMovedSuccess] = useState<boolean>(false);
	const navigate = useNavigate();

	const handleClose = () => {
		setMessageSnack(undefined);
	};

	function setPopupErrorMessage(show: boolean, message: string) {
		setMessageSnack(message);
		setShowSnackBar(show);
		setAlertColor("error");
	}

	function setPopupOkMessage(show: boolean, message: string) {
		setMessageSnack(message);
		setShowSnackBar(show);
		setAlertColor("success");
	}
    const [waitingDelete, setWaitingDelete] = useState<boolean>(false);

	const { width } = usePanelWidth({
		idFileRevision: idFileRevision,
		temporalityConfig: temporalityConfig,
		copyFolderStructureDrawerParameters: copyFolderStructureDrawerParameters
	});
	
	const { configSearch, setconfigSearch } = useSearchConfig();

	const handleCloseSnackBar = (event: any, reason: any) => {
		setShowSnackBar(false);
	};

	const closeModal = () => {
		setIsModalOpen(false)
	};

	const handleCloseSnackBarPO = (event: any) => {
		setShowSnackBar(false);
	};

	function getSearchType(input: string): SearchType {
		switch(input) {
			case "onlyDocuments":
				return SearchType.ONLYMYDOCUMENTS;
			case "folder":
				return SearchType.FOLDER;
			default:
				return SearchType.DEFAULT;
		}
	}

	useEffect(() => {
		if (reload == true) {
			setReload(false);
		}
	}, [reload]);

	const resetPanel = () => {
		dismissPanel();
		setEditFolderOpen(undefined);
		setIdFileRevision(undefined);
		setNewFolderConfig(undefined);
		setRenameConfig(undefined);
		setTemporalityConfig(undefined)
		setShareFileConfigOpen(undefined);
		setHideDialog(true);
		setHideDialogMove(true);
		setCopyFolderStructureDrawerParameters(undefined)
	};

	const updatePanelSave = () => {
		setMessageSnack(t("Folder.save"));
		setAlertColor("success");
		resetPanel();
		setReload(true);
		setShowSnackBar(true);
		upload.setShowEx(false);
	};

	const updateDrawerSave = () => {
		setMessageSnack(t("Folder.save"));
		setAlertColor("success");
		setShowSnackBar(true);
		setIsOpenDrawer(false);
	};

	const updatePanelSaveTemporality = () => {
		setMessageSnack(t("Folder.save"));
		setAlertColor("success");
		resetPanel();
		//setReload(true);
		setShowSnackBar(true);
		upload.setShowEx(false);
	};

	const ResetTemporality = () => {
		setMessageSnack(t("Reset.message"));
		setAlertColor("success");
		resetPanel();
		//setReload(true);
		setShowSnackBar(true);
		upload.setShowEx(false);
	};

	const reloadFolders = () => {
		setMessageSnack(t("SucessMove.message"));
		setAlertColor("success");
		setReload(true);
		setShowSnackBar(true);
	}

	useEffect(()=>{
		if(upload.fileList?.length == 0)
			setReload(true)
	},[upload.fileList?.length])

	const setIdFolderExternal = (folderId: string | undefined, searshParams:string | undefined ) => {
		navigate(`/${nameOrg}/wsallowed/${idWorkspace}/${folderId??""}`);

		if(searshParams == "" || searshParams == undefined)
		{
			searchParams.delete("search");
			searchParams.delete("tag");
		}

		setIdFolderInternal(folderId);

		var folder = searchParams.get("folder");
		let searchType = searchParams.get("searchType");
		let bySearch = Boolean(searchParams.get("bySearch"));
		
		if(idWorkspace != undefined)
		{
			setconfigSearch({
				idWorkspace: idWorkspace,
				idFolder: folderId,
				search: searshParams,
				folder:folder!,
				idTag:"",
				searchType: getSearchType(searchType!),
				bySearch: bySearch
			})
		}
	};

	useEffect(()=>{
		setIdFolderInternal(idFolder)
	},[idFolder])

	useEffect(() => {
		if (itemMove != "") {
			GetOneItem(itemMove)
			.then(data => {
				console.log("item", data)
				setFileToMove({
					extension: data?.extension!,
					id: data?.id!,
					isFolder: data?.itemType == "folder",
					isRelease: data?.isRelease!,
					name: data?.name!,
					validationRule: data?.validationRule!,
				})
			})
		}
	}, [itemMove])

	useEffect(() =>{
		let search = searchParams.get("search");
		let tag = searchParams.get("tag");

		var folder = searchParams.get("folder");
		let searchType = searchParams.get("searchType");
		let bySearch = Boolean(searchParams.get("bySearch"));

		if(idWorkspace != undefined)
		{
			if(!search || search == "")
			{
				if(!tag || tag == ""){
					setconfigSearch({
						idWorkspace: idWorkspace,
						idFolder: idFolder,
						search: "",
						folder:folder!,
						idTag:"",
						searchType: getSearchType(searchType!),
						bySearch: bySearch
					})
				}
				else{
					setconfigSearch({
						idWorkspace: idWorkspace,
						idFolder: idFolder,
						search: "",
						folder:folder!,
						idTag:tag,
						searchType: getSearchType(searchType!),
						bySearch: bySearch
					})
				}
			}
			else
			{
				setconfigSearch({
					idWorkspace: idWorkspace,
					idFolder: idFolder,
					search: search,
					folder:folder!,
					idTag:tag!,
					searchType: getSearchType(searchType!),
					bySearch: bySearch
				})
			}			
		}
	},[searchParams, idWorkspace, idFolder])


	function setIdFileRevisionExternal(file: string) {
		resetPanel();
		setIdFileRevision(file);
		openPanel();
	}

	function setIdFileRevisionMoveExternal(file: string) {
		setIsModalOpen(true);
		setItemMove(file);
		setHideDialogMove(false);
	}

	function setRenameConfigExternal(renameConfig: RenameConfig) {
		resetPanel();
		setRenameConfig(renameConfig);
		openPanel();
	}

	function setTemporalityConfigExternal(temporalityConfig: TemporalityConfig){
		resetPanel();
		setTemporalityConfig(temporalityConfig)
		openPanel();
	}

	function setShareFileConfigOpenExternal(shareFileConfig: ShareFileConfig) {
		setShareFileConfigOpen(shareFileConfig);
		setIsOpenDrawer(true);
	}

	function setFolderConfig(newFolder: NewFolderConfig) {
		resetPanel();
		setNewFolderConfig(newFolder);
		setReloadFolder(true);
		openPanel();
	}

	function setEditFolderOpenExternal(editFolderOpenParameter: EditFolderOpen) {
		resetPanel();
		setEditFolderOpen(editFolderOpenParameter);
		openPanel();
	}

	function setCopyFolderStructureDrawerParametersExternal(copyFolderStructureDrawerParameters: CopyFolderStructureDrawerParameters) {
		resetPanel();
		setCopyFolderStructureDrawerParameters(copyFolderStructureDrawerParameters);
		openPanel();
	}

	function OpenRevision(itemId: string) {
		resetPanel();
		setIdFileRevision(itemId);
		openPanel();
	}

	useEffect(() => {
		if (idFileDeted != undefined) {
			setHideDialog(false);
			GetOneItem(idFileDeted).then(data => {
				setItemDelete(data);
			}).catch(() => {
				setItemDelete(undefined);
			})
		} else {
			setHideDialog(true);
			setItemDelete(undefined);
		}
	}, [idFileDeted]);

	function closeHideDialog(){
		setHideDialog(true)
		setIdFileDeted(undefined)
	}

	function deleteItem(folderId: string) {
		setIdFileDeted(folderId);
	}

    const handleOpen = () => {
		setOpenModalFlow(true)
	  }
  
	  const handleclose = () => {
		setOpenModalFlow(false)
	  }
	  
	function openFlowComp(flowProps: FlowProps){
		setFlowProps(flowProps);
		handleOpen();
	}

	function deleteOk() {
		if (idFileDeted != undefined) {
            setWaitingDelete(true);
			DeleteItem(idFileDeted)
				.then((returnMessage) => {
					setMessageSnack(t("Item.deleteSucess"));
					setAlertColor("success");
					setHideDialog(true);
					setReload(true);
					setShowSnackBar(true);
				})
				.catch((returnError) => {
					if (returnError.response) {
						setMessageSnack(returnError.response.data);
					} else {
						setMessageSnack(t("Folder.deleteProblem"));
					}
					setAlertColor("error");
					setHideDialog(true);
					setShowSnackBar(true);
				})
				.finally(()=>{
					setIdFileDeted(undefined);
                    setWaitingDelete(false);
				});
		}
	}

  function HeaderAltern (): string {

    if (idFileRevision != undefined) {
      return t("Revisao.term")
    }

    if (idFileRevision == undefined) {
      return t("Folder.toSave")
    }

    return ""
  }

	interface CheckboxItemList {
		boxLayout: boolean
		checkBox: { myDiv: "", default: "" }
		onChange: any
		value: string
		id: string
		name: string
	}

  const CheckboxItemList: React.FC<CheckboxItemList> = ({
		boxLayout,
		checkBox,
		onChange,
		value,
		id,
		name
	}) => {

    const Checkbox = 
    <div className={boxLayout?checkBox.myDiv:checkBox.default}>
      <input 
          type="checkbox" 
          onChange={onChange}     
          value={value}   
          id={id}   
          name={name}       
        />
      </div> 

		return Checkbox
	}

	const showSnackbar = (message: string, type: "success" | "error") => {
		setMessageSnack(message)
		setAlertColor(type)
		setShowSnackBar(true)
	}

	return (
		<div className={styles.main}>
			{reload == false && idWorkspace != undefined && nameOrg != undefined && configSearch != undefined && (
				<WorkSpaceItemListFolder
					nameOrg={nameOrg}
					configSearch={configSearch}
					setFolderConfig={setFolderConfig}
					deleteItem={deleteItem}
					onClickRevision={setIdFileRevisionExternal}
					onclikMoveOpen={setIdFileRevisionMoveExternal}
					editFolderOpen={setEditFolderOpenExternal}
					rename={setRenameConfigExternal}
					temporalityDocument={setTemporalityConfigExternal}
					setIdFolder={setIdFolderExternal}
					setShareFileConfig={setShareFileConfigOpenExternal}
					reloadFolder={reloadFolder}
					CheckboxItemList={CheckboxItemList}
					reloadFolders={reloadFolders}
					onClickFlow={openFlowComp}
					setCopyFolderStructureDrawerParametersExternal={setCopyFolderStructureDrawerParametersExternal}
				/>
			)}
			<Panel
				isOpen={isOpen}
				closeButtonAriaLabel={t("Fechar.message")}
				onDismiss={resetPanel}
				headerText={newFolderConfig != undefined ? t("NewFolder.title"): ""}
				isFooterAtBottom={true}
				type={idFileRevision != undefined ? PanelType.medium : undefined}
				styles={{content:{padding:"0px 30px 40px 30px"},main:{width: `${width.commonWidth}`, justifyContent:"center"},header:{margin:"40px 0px 24px 6px"},headerText:{fontSize:"28px", fontWeight:"bold", color:"#2D2D2D"}}}
			>
				{newFolderConfig != undefined && (
					<CreateFolderComp newFolderConfig={newFolderConfig} saveOkMetod={updatePanelSave} />
				)}

				{renameConfig != undefined && (
					<RenameComp renameConfig={renameConfig} saveOkMetod={updatePanelSave} />
				)}

				{idFileRevision != undefined && (
					<WorkSpaceItemListFileRevisionComponent idItem={idFileRevision} idFolderInternal={idFolderInternal!} />
				)}

				{temporalityConfig != undefined && (
					<ValidateDocument temporalityConfig={temporalityConfig} saveOkMetod={updatePanelSaveTemporality} resetOkMetod={ResetTemporality} resetPanel={resetPanel}/>
				)}

				{editFolderOpen != undefined && nameOrg != undefined &&(
				<EditFolder
					nameOrg={nameOrg}
					saveOkMetod={updatePanelSave}
					editFolderOpen={editFolderOpen}
				/>
				)}

				{copyFolderStructureDrawerParameters != undefined && (
					<CopyFolderStructureDrawer 
						copyFolderStructureDrawerParameters={copyFolderStructureDrawerParameters}
						saveOkMetod={updatePanelSave}
						showSnackbar={showSnackbar}
					/>
				)}
      </Panel>
	
			<KeyDriveDrawer isOpen={isOpenDrawer}>
				{shareFileConfigOpen != undefined && (
					<ShareFile
						saveOkMetod={updateDrawerSave}
						shareFileConfig={shareFileConfigOpen}
						setMessageSnackbar={setMessageSnack}
						setShowSnackBar={setShowSnackBar}
						setAlertColor={setAlertColor}
						onClose={() => setIsOpenDrawer(false)}
					/>
				)}
			</KeyDriveDrawer>
	
	  	{ openModalFlow && flowProps && (
            <div className={stylesTimeLine.dialogContainer}>
               	<WorkspaceItemFlowComponent  handleClose={handleclose} flowProps={flowProps}/>
            </div>
        )}
			<KeyDriveDialog 
					keyDriveDialogContent={{
					  dialogTitle: t(itemDelete?.itemType == "folder" ? "Item.deleteMessageFolder": "Item.deleteMessageFile"),
					  dialogContent: t("Item.deleteDescription", { itemName: `${itemDelete?.name}${itemDelete?.itemType == "file" ? "."+itemDelete.extension: ""}` }),
					  openDialog: !hideDialog,
					  dialogIcon: <Delete sx={{
											  width: "40px",
											  height: "44px",
											  color: "#22638D"
										  }} />,
					  handleTogglDialog: () => {}
					}}
					keyDriveDialogButtons={{
					  rightButtonText: t("Excluir.message"),
					  leftButtonText: t("Cancelar.message"),
					  rightButtonMethod: deleteOk,
					  leftButtonMethod: closeHideDialog
					}}
					dialogTitleCenter
				  />
			<MoveInBatch
				hideModal={closeModal}
				isModalOpen={isModalOpen}
				listItem={[fileToMove!]}
				isMovingOneItem={true}
				batchRefresh={reloadFolders}
				idWorkspace={idWorkspace!}
			/>

			<KeydriveSnackbar 
				open={messageSnack != undefined}
				variant={alertColor}
				message={messageSnack}
				onClose={handleClose}
			/>
		</div>
	);
};

export default WorkSpaceItemMain;
